import TitleA from './common/TitleA.vue';
import ButtonA from './common/ButtonA.vue';
import FilterTag from './common/FilterTag.vue';
import Sum from './common/Sum.vue';
import Tag from './common/Tag.vue';
import ArticleA from './common/ArticleA.vue';

const myCompenent = {
    install: function(Vue) {
        // 注册并获取组件，然后在main.js中引用，在Vue.use()就可以了
        Vue.component('Sum', Sum);
        Vue.component('Tag', Tag);
        Vue.component('FilterTag', FilterTag);
        Vue.component('ButtonA', ButtonA);
        Vue.component('TitleA', TitleA);
        Vue.component('ArticleA', ArticleA);
    }
}

export default myCompenent